export { default } from './AnomaliesPanel';
